import * as components from './components';
import * as constants from './constants';
import reducer from './reducer';

export default { components, constants, reducer };
